export const getProductType = () : "annie"|"zoomon"|"buddy"|null => {

    if (window.location.hostname.includes('anniebabymonitor')) { return "annie"; }
    if (window.location.hostname.includes('zoomon')) { return "zoomon"; }
    if (window.location.hostname.includes('dogmonitor') || window.location.hostname.includes('buddy')) { return "buddy"; }
    return 'annie';
}
